import { FlowGraph } from "./flowGraph.js";
import { FlowGraphEventCoordinator } from "./flowGraphEventCoordinator.js";
/**
 * @experimental
 * Parameters used to create a flow graph engine.
 */
export class IFlowGraphCoordinatorConfiguration {
}
/**
 * This class holds all of the existing flow graphs and is responsible for creating new ones.
 * It also handles starting/stopping multiple graphs and communication between them through an Event Coordinator
 */
export class FlowGraphCoordinator {
    constructor(_config) {
        var _a;
        this._config = _config;
        this._flowGraphs = [];
        this._eventCoordinator = new FlowGraphEventCoordinator();
        // When the scene is disposed, dispose all graphs currently running on it.
        this._config.scene.onDisposeObservable.add(() => {
            this.dispose();
        });
        // Add itself to the SceneCoordinators list for the Inspector.
        const coordinators = (_a = FlowGraphCoordinator.SceneCoordinators.get(this._config.scene)) !== null && _a !== void 0 ? _a : [];
        coordinators.push(this);
    }
    /**
     * Creates a new flow graph and adds it to the list of existing flow graphs
     * @returns a new flow graph
     */
    createGraph() {
        const graph = new FlowGraph({ scene: this._config.scene, eventCoordinator: this._eventCoordinator });
        this._flowGraphs.push(graph);
        return graph;
    }
    /**
     * Removes a flow graph from the list of existing flow graphs and disposes it
     * @param graph the graph to remove
     */
    removeGraph(graph) {
        const index = this._flowGraphs.indexOf(graph);
        if (index !== -1) {
            graph.dispose();
            this._flowGraphs.splice(index, 1);
        }
    }
    /**
     * Starts all graphs
     */
    start() {
        this._flowGraphs.forEach((graph) => graph.start());
    }
    /**
     * Disposes all graphs
     */
    dispose() {
        var _a;
        this._flowGraphs.forEach((graph) => graph.dispose());
        this._flowGraphs.length = 0;
        // Remove itself from the SceneCoordinators list for the Inspector.
        const coordinators = (_a = FlowGraphCoordinator.SceneCoordinators.get(this._config.scene)) !== null && _a !== void 0 ? _a : [];
        const index = coordinators.indexOf(this);
        if (index !== -1) {
            coordinators.splice(index, 1);
        }
    }
}
/**
 * @internal
 * A list of all the coordinators per scene. Will be used by the inspector
 */
FlowGraphCoordinator.SceneCoordinators = new Map();
//# sourceMappingURL=flowGraphCoordinator.js.map